<template>
  <TableCell v-bind="$attrs" 
    :tag="tag"
    :popoverDisabled="readOnly"
    :popoverTitle="popoverTitle"
    :selectedCells="selectedCells"
    v-model:showingPopover="showingPopover"
    v-model:columnSelectionCode="columnSelectionCode"
  >
    {{ selectedOption.caption }}
    <template #PopoverContentDesktop="{helpText}">
      <ListSettingPopoverContent
        v-bind:showingPopover="showingPopover"
        :popoverTitle
        :options
        :selectedOption
        :onOptionSelected
        :selectedCells
        :showingDisableSetting
        :helpText
        @selectOption="onOptionSelected"
        @disableSetting="onClickDisableSetting"
      >
        <template #BinSelectionInput>
          <slot name="BinSelectionInput"></slot>
        </template>
      </ListSettingPopoverContent>
    </template>
  </TableCell>
</template>

<script setup>
import { computed } from "vue";
import { changeSettings, toggleOptionalSettings } from "./appUtility";
import store from "./store";
import ListSettingPopoverContent from "./ListSettingPopoverContent.vue";

let props = defineProps([
  "tag",
  "showingPopover",
  "popoverTitle",
  "selectedCells",
  "applyToAllColumnsEnabled",
  "columnSelectionCode",
  "options",
  "onOptionSelected",
  "readOnly"
]);

let showingPopover = defineModel("showingPopover");
let columnSelectionCode = defineModel("columnSelectionCode");

let selectedOption = computed(() => {
  return props.options.find(option => option.value == props.tag.$value())
});

let showingDisableSetting = computed(() => (
  store.showAdvanced &&
  props.tag.settingOptional &&
  props.tag.settingEnabled &&
  props.tag.relevant
));

function onClickDisableSetting() {
  toggleOptionalSettings(props.selectedCells, false);
}
</script>